module.exports = __webpack_public_path__ + "img/system-county-bm.f41947f9.png";